import produce from "immer";
import { IStoreState } from "../..";
import {
  defaultVendorPayment,
  defaultVendorPaymentState,
} from "./vendor-payments.state";
import {
  CLEAR_SINGLE_VENDOR_PAYMENT_STATE,
  CLEAR_VENDOR_PAYMENT_LIST_STATE,
  FETCH_SINGLE_VENDOR_PAYMENT_FAILED,
  FETCH_SINGLE_VENDOR_PAYMENT_PROGRESS,
  FETCH_SINGLE_VENDOR_PAYMENT_SUCCESS,
  FETCH_VENDOR_PAYMENT_LIST_FAILED,
  FETCH_VENDOR_PAYMENT_LIST_PROGRESS,
  FETCH_VENDOR_PAYMENT_LIST_SUCCESS,
} from "./vendor-payments.actions";
import { LoadState } from "../../../constants/enums";
import { VendorPaymentsActions } from ".";

export const vendorPaymentsReducer = (
  state: IStoreState["vendorExpense"] = defaultVendorPaymentState,
  action: VendorPaymentsActions,
) => {
  switch (action.type) {
    case FETCH_VENDOR_PAYMENT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.vendor_payments_list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_VENDOR_PAYMENT_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.vendor_payments_list.loading = LoadState.Loaded;
        draftState.vendor_payments_list.data = data;
        draftState.vendor_payments_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_VENDOR_PAYMENT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.vendor_payments_list.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_SINGLE_VENDOR_PAYMENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_vendor_payment.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_VENDOR_PAYMENT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_vendor_payment.loading = LoadState.Loaded;
        draftState.single_vendor_payment.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_VENDOR_PAYMENT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_vendor_payment.loading = LoadState.Failed;
        draftState.single_vendor_payment.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_SINGLE_VENDOR_PAYMENT_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.single_vendor_payment.loading = LoadState.NotLoaded;
        draftState.single_vendor_payment.data = defaultVendorPayment;
      });
      return newState;
    }
    case CLEAR_VENDOR_PAYMENT_LIST_STATE: {
      return defaultVendorPaymentState;
    }
    default: {
      return state;
    }
  }
};
